import React from 'react';
import { useSelector } from 'react-redux';
import { Image, View, StyleSheet, TouchableOpacity } from 'react-native';
import moment from 'moment';

import RowView from '../RowView';
import BaseText from '../BaseText';
import Images from '../../constants/Images';
import { formatCurrency } from '../../utils/currency.utils';
import { CommonStyles, Color, CommonProperties } from '../../styles';
import { scale } from '../../utils/scale.utils';
import { selectCompanyCurrencyCulture } from '../../store/selectors/auth.selector';
import { isNullOrEmpty } from '../../utils/common.utils';

const getFormattedChargeDate = (item) => {
  const chargeDate = isNullOrEmpty(item.Charge) ? item.ChargeDate : item.Charge?.ChargeDate;
  return chargeDate ? moment(chargeDate).format('MMM DD') : '';
};

const ExpenseSummaryCard = ({
  item = {},
  showExclamationIcon = false,
  onPress,
  pressDisabled = true,
  isEditable,
}) => {
  const currency = item?.Currency || 'USD';
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);

  return (
    <View style={styles.expenseItem}>
      <TouchableOpacity onPress={onPress} disabled={pressDisabled}>
        <RowView style={styles.row}>
          {/* First Column */}
          <View style={styles.columnFirst}>
            <Image
              style={styles.image}
              source={item.Image ? { uri: item.Image } : Images.default.expense}
            />
          </View>

          {/* Second Column */}
          <View style={styles.columnSecond}>
            <RowView style={styles.rowBetween}>
              <BaseText
                style={[CommonStyles.h4, { color: !isEditable ? Color.grayText2 : Color.primary }]}
              >
                {item.Merchant ? item.Merchant : item.ExpenseName}
              </BaseText>
              <BaseText style={[CommonStyles.h2, styles.priceStyle]}>
                {formatCurrency(item.Amount, currency, currencyCulture, 2)}
              </BaseText>
            </RowView>
            <RowView style={styles.rowBetween}>
              <BaseText style={styles.time}>{getFormattedChargeDate(item)}</BaseText>
              {showExclamationIcon && (
                <Image
                  source={require('../../assets/images/exclamation-icon.png')}
                  style={styles.exclamationIconStyle}
                />
              )}
            </RowView>
          </View>
        </RowView>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  expenseItem: {
    backgroundColor: Color.accent,
    borderBottomColor: Color.disabled,
    borderBottomWidth: 1,
  },
  row: {
    paddingHorizontal: scale(24),
    ...CommonProperties.py3,
  },
  rowBetween: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: scale(5),
  },
  columnFirst: {
    width: '20',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: scale(5),
  },
  columnSecond: {
    flex: 1,
    justifyContent: 'space-between',
  },
  image: {
    width: scale(56),
    height: scale(56),
    borderRadius: scale(28),
  },
  time: {
    color: Color.text.medium,
    ...CommonProperties.small,
  },
  priceStyle: {
    color: Color.black,
  },
  exclamationIconStyle: {
    width: scale(20),
    height: scale(20),
  },
});

export default ExpenseSummaryCard;
